export default __webpack_public_path__ + "static/media/Error.117f72c8.png";